// This is intentionally not generated using updateIndexes script
// The BlocklyEditorProxy will lazy load the BlocklyEditor (which is large)
import _BlocklyEditor from './BlocklyEditorProxy';
import _DataDictionaryViewer from './DataDictionaryViewer';
import _MenuEditor from './MenuEditor';
export const BlocklyEditor = _BlocklyEditor;
export const DataDictionaryViewer = _DataDictionaryViewer;
export const MenuEditor = _MenuEditor;
export default { BlocklyEditor, DataDictionaryViewer, MenuEditor };
